import { useSelector } from "react-redux";

import { Navigate } from "react-router";

import PlayerList from "./PlayerList";

const Players = () => {
  const integrationType = useSelector(
    (state) => state?.auth?.user?.integrationType
  );
  if (integrationType === 1) {
    return <Navigate to="/analytics/videos" />;
  }
  return <PlayerList />;
};

export default Players;
